export default function chip({ variables }) {
    return {
        MuiChip: {
            defaultProps: {
                size: "small",
            },
            styleOverrides: {
                root: {
                    margin: `0 ${variables.spacing_03} ${variables.spacing_03} 0`,
                    height: "24px",
                    borderRadius: variables.border_radius_pill,
                    border: `1px solid ${variables.border_subtle}`,
                    backgroundColor: variables.surface_subtle,
                    color: variables.text_primary,
                    fontSize: variables.type_body_sm_font_size,
                    fontWeight: variables.font_weight_medium,
                    "&:hover": {
                        backgroundColor: variables.surface_hover,
                    },
                },
                label: {
                    paddingLeft: variables.spacing_03,
                    paddingRight: variables.spacing_03,
                },
                outlined: {
                    borderColor: variables.border_subtle,
                    backgroundColor: variables.surface_subtle,
                },
            },
        },
    };
}
//# sourceMappingURL=chip.js.map